<template>
  <div class="p-6 bg-white/60 rounded-xl min-h-screen">
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
      <h5 class="text-l font-bold text-gray-800 inline-block transition-all duration-500">
        <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse"> خروجی دستی
        </span>
      </h5>

      <div class="flex gap-2 mr-3">
        <button
            @click="syncExportSession"
            class="px-3 py-1.5 bg-white rounded-lg shadow-sm hover:shadow-md text-[10px] text-gray-700 transition-all duration-300 hover:bg-gray-50 transform hover:scale-105"
        >
          بروزرسانی سشن
        </button>

        <button
            @click="resetExport"
            class="px-3 py-1.5 bg-gradient-to-r from-gray-500 to-red-600 text-white rounded-lg shadow-sm hover:shadow-md text-[10px] transition-all duration-300 transform hover:scale-105"
        >
          حذف لیست انتخاب
        </button>

        <button
            @click="exportXlsx"
            :disabled="exportItemsCount === 0 || exporting"
            class="px-3 py-1.5 bg-gradient-to-r from-blue-500 to-emerald-500 text-white rounded-lg shadow-sm hover:shadow-md text-[10px] transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span v-if="!exporting">خروجی اکسل ({{ exportItemsCount }} مورد)</span>
          <span v-else>در حال ساخت فایل...</span>
        </button>
      </div>
    </div>

    <!-- Filters -->
    <div class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-3 mb-6 shadow-sm border border-gray-100 relative z-30">
      <div class="flex flex-wrap items-center gap-2">
        <div class="relative w-32">
          <input
              v-model="filters.search_value"
              placeholder="نام"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <input
              v-model="filters.sku"
              placeholder="SKU"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <input
              v-model="filters.id_in"
              placeholder="شناسه"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              @keyup.enter="applyFilters"
          >
        </div>
        <!-- Price Range -->
        <div class="flex gap-1 w-48">
          <input
              v-model="filters.min_price"
              placeholder="حداقل قیمت"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              type="number"
              @keyup.enter="applyFilters"
          >
          <input
              v-model="filters.max_price"
              placeholder="حداکثر قیمت"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              type="number"
              @keyup.enter="applyFilters"
          >
        </div>
        <!-- Inventory -->
        <div class="flex gap-1 w-48">
          <input
              v-model="filters.min_inventory"
              placeholder="حداقل موجودی"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              type="number"
              @keyup.enter="applyFilters"
          >
          <input
              v-model="filters.max_inventory"
              placeholder="حداکثر موجودی"
              class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
              type="number"
              @keyup.enter="applyFilters"
          >
        </div>
        <searchable-select v-model="filters.brand_in" :options="brands"
                           placeholder="همه برندها"
                           class="w-32 "
                           style="z-index: 999999"
                           @change="applyFilters"
        ></searchable-select>
        <select
            @change="applyFilters"
            v-model="filters.currency_in"
            class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
        >
          <option value="">همه ارزها</option>
          <option
              v-for="currency in currencies"
              :key="currency.id"
              :value="currency.id"
          >
            {{ currency.name }}
          </option>
          <option value="null">بدون ارز</option>
        </select>
        <div class="flex gap-1">
          <button
              @click="resetFilters"
              class="p-1.5 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="حذف فیلترها"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
          <button
              @click="applyFilters"
              class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="اعمال فیلتر"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-50 bg-opacity-70">
          <tr>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">شناسه</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
            <th class="p-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">محصول</th>
            <th class="p-3 text-center text-[6px] text-gray-500">قیمت پایه</th>
            <th class="p-3 text-center text-[6px] text-gray-500">قیمت خروجی</th>
            <th class="p-3 text-center text-[6px] text-gray-500">موجودی</th>
            <th class="p-3 text-center text-[6px] text-gray-500">مقدار برای خروجی</th>
            <th class="p-3 text-center text-[6px] text-gray-500">وضعیت</th>
            <th class="p-3 text-center text-[6px] text-gray-500"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="6" class="p-4 text-center">
              <div class="flex justify-center items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                در حال بارگذاری...
              </div>
            </td>
          </tr>
          <tr v-else-if="products.length === 0">
            <td colspan="6" class="p-4 text-center text-gray-500">
              محصولی یافت نشد
            </td>
          </tr>

          <tr
              v-for="product in products"
              :key="product.id"
              class="border-t border-gray-100 hover:bg-gray-50 transition-colors duration-200"
              :class="{'bg-green-100': isInExport(product)}"
          >
            <td class="p-3 font-medium text-[9px] text-gray-900">{{ product.id || ' بدون شناسه'}}</td>
            <td class="p-3 font-medium text-[9px] text-gray-900" v-if="product.skus.length === 1">{{ product.sixteen_digit_code || ' بدون کد'}}
            </td>
            <td class="p-3 font-medium text-[9px] text-gray-900" v-else>
              <p v-for="sku in product.skus"> {{sku}}</p>
            </td>
            <td class="p-3">
              <div class="flex items-center gap-3">
                <div class="relative" v-if="product.image">
                  <img
                      :src="img_source(product.image)"
                      class="w-10 h-10 rounded-lg object-cover border border-gray-200 shadow-sm"
                  >
                </div>
                <div class="min-w-0">
                  <div
                      class="text-[9px] font-medium text-gray-900 leading-4
                 whitespace-normal break-words max-w-[150px]"
                  >
                    {{ product.name }}
                  </div>
                  <div class="text-[9px] text-gray-500 mt-1">
                    {{ product.sixteen_digit_code }}
                  </div>
                  <div
                      class="text-[9px] text-gray-500 mt-1 flex items-center gap-1"
                      v-if="product.product_type == 'variation'"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
                    </svg>
                    {{ product.variation_of_name }}
                  </div>
                </div>
              </div>
            </td>

            <td class="text-center p-3 text-[13px]">
              <span class="px-2 py-1 bg-gray-100 rounded-lg">
                {{ product.base_price | toMoney(4)}} <span class="text-[8px]">{{product.currency_name}}</span>
              </span>
            </td>

            <td class="text-center p-3 text-[13px]">
              <cleave-money
                  label=" "
                  :bg-color="`${exportPriceClass(product)} max-w-xs`"
                  v-model="product.export_price"
                  :currency-unit="product.currency_name"
              ></cleave-money>

            </td>
            <td class="text-center p-3 text-[13px]">
              <span class="px-2 py-1 bg-gray-100 rounded-lg">
                {{ product.inventory_count }}
              </span>
            </td>

            <!-- Value input -->
            <td class="items-center text-center p-3 text-[9px]">
              <input
                  type="number"
                  min="0"
                  :max="product.inventory_count"
                  step="any"
                  v-model.number="product.export_value"
                  @input="handleExportValueInput(product)"
                  placeholder="مقدار"
                  class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-24 text-center"
              />
            </td>

            <!-- Status -->
            <td class="items-center text-center p-3 text-[9px]">
              <span
                  v-if="isInExport(product)"
                  class="inline-flex items-center px-2 py-1 rounded-full bg-green-100 text-green-700 text-[9px]"
              >
                در لیست خروجی
              </span>
              <span
                  v-else
                  class="inline-flex items-center px-2 py-1 rounded-full bg-gray-100 text-gray-500 text-[9px]"
              >
                انتخاب نشده
              </span>
            </td>

            <!-- Actions -->
            <td class="items-center text-center p-3 text-[9px]">
              <button
                  @click="addToExport(product)"
                  :disabled="!product.export_value && product.export_value !== 0"
                  class="px-3 py-1.5 bg-green-600 text-white text-[9px] rounded-full hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                ثبت در سشن
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="p-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="text-sm text-gray-600">
          نمایش {{ (currentPage - 1) * itemsPerPage + 1 }} تا
          {{ Math.min(currentPage * itemsPerPage, totalProducts) }} از
          {{ totalProducts }} محصول
        </div>
        <div class="flex gap-1">
          <button
              @click="prevPage"
              :disabled="currentPage === 1"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>

          <button
              v-for="page in visiblePages"
              :key="page"
              @click="goToPage(page)"
              class="p-2 text-center border border-gray-200 rounded-full transition-colors duration-200"
              :class="{
              'bg-gradient-to-r from-blue-500/60 to-blue-600/50 text-white shadow-md': page === currentPage,
              'bg-white bg-opacity-50 hover:bg-gray-50': page !== currentPage,
              'cursor-default': page === '...'
            }"
              :disabled="page === '...'"
          >
            {{ page }}
          </button>

          <button
              @click="nextPage"
              :disabled="currentPage * itemsPerPage >= totalProducts"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Toast -->
    <transition name="slide-fade">
      <div v-if="toast.show"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-[90%] max-w-xs text-gray-100 bg-gray-900 rounded-lg shadow-lg border border-gray-700">

        <div
            class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-400 bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"/>
          </svg>
        </div>

        <div class="mr-3 text-sm font-normal pr-2">{{ toast.message }}</div>

        <button @click="toast.show = false"
                class="mr-auto text-gray-400 hover:text-white rounded-lg p-1.5 hover:bg-gray-800">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>
    <transition name="slide-fade">
      <div
          v-if="exportConfirmVisible"
          class="fixed inset-0 z-40 flex items-center justify-center bg-black/40"
      >
        <div class="bg-white rounded-2xl shadow-xl max-w-sm w-[90%] p-5 border border-gray-200">
          <div class="flex items-center justify-between mb-3">
            <h3 class="text-sm font-semibold text-gray-800">
              خلاصه خروجی دستی
            </h3>
            <button
                class="text-gray-400 hover:text-gray-600"
                @click="exportConfirmVisible = false"
            >
              ✕
            </button>
          </div>

          <div class="space-y-2 text-xs text-gray-700 mb-4">
            <div class="flex justify-between">
              <span>تعداد کل اقلام انتخاب‌شده:</span>
              <span class="font-semibold">{{ exportSummary.totalQuantity }}</span>
            </div>
            <div class="flex justify-between">
              <span>مجموع مبلغ تقریبی:</span>
              <span class="font-semibold">
            {{ exportSummary.totalAmount | toMoney(4) }}
          </span>
            </div>
          </div>

          <div class="flex flex-col gap-2">
            <button
                @click="confirmExportDownload"
                class="w-full px-3 py-2 text-xs rounded-lg bg-gradient-to-r from-blue-500 to-emerald-500 text-white text-center font-medium shadow hover:shadow-md transition-all"
            >
              دانلود فایل اکسل
            </button>
            <button
                @click="confirmExportFinalize"
                class="w-full px-3 py-2 text-xs rounded-lg bg-gradient-to-r from-red-500 to-rose-500 text-white text-center hover:bg-red-900 transition-all"
            >
              تأیید خروجی
            </button>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import SearchableSelect from "@/components/selects/SearchableSelect";
import CleaveMoney from "@/components/mcomponents/cleave/Money";
export default {
  name: 'InventoryExportSelector',
  components: {CleaveMoney, SearchableSelect},
  data() {
    return {
      loading: true,
      exporting: false,
      products: [],
      totalProducts: 0,
      currentPage: 1,
      itemsPerPage: 20,
      filters: {
        id_in: '',
        search_value: '',
        sku: '',
        min_price: '',
        max_price: '',
        min_inventory: '',
        max_inventory: '',
        category_tree: '',
        brand_in: '',
        status_in: '',
        content_status: '',
        catalog_need: '',
        currency_in: '',
        is_ai: null,
        supplier: ''
      },
      categories: [],
      brands: [],
      avails: [],
      features: [],
      currencies: [],
      exportSession: {},
      exportConfirmVisible: false,
      exportSummary: {
        totalQuantity: 0,
        totalAmount: 0
      },
      toast: {
        show: false,
        message: ''
      }
    }
  },
  computed: {
    exportItemsCount() {
      return Object.keys(this.exportSession).length
    },
    visiblePages() {
      const totalPages = Math.ceil(this.totalProducts / this.itemsPerPage)
      const range = 1
      const pages = []

      if (!totalPages || totalPages <= 1) {
        return [1]
      }

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
  },
  methods: {
    computeExportSummary() {
      let totalQuantity = 0
      let totalAmount = 0

      const items = Object.values(this.exportSession || {})

      for (let item of items) {
        const q = Number(item.value) || 0
        const p = Number(item.price) || 0
        totalQuantity += q
        totalAmount += q * p
      }

      this.exportSummary.totalQuantity = totalQuantity
      this.exportSummary.totalAmount = totalAmount
    },
    exportPriceClass(product) {
      const base = Number(product.base_price) || 0
      const price = Number(product.export_price)

      if (isNaN(price)) {
        return ''
      }

      if (price < base) {
        return 'text-red-600'
      }
      if (price > base) {
        return 'text-emerald-600'
      }
      return 'text-blue-600'
    },

    applyExportSessionToProducts() {
      if (!this.products || !this.products.length) return

      this.products.forEach(p => {
        const entry = this.exportSession[p.id]
        if (entry) {
          this.$set(p, 'export_value', entry.value)
          const effectivePrice =
              entry.price !== null && entry.price !== undefined && entry.price !== 0
                  ? entry.price
                  : p.base_price
          this.$set(p, 'export_price', effectivePrice)
        } else {
          if (p.export_price === undefined || p.export_price === null) {
            this.$set(p, 'export_price', p.base_price)
          }
        }
      })
    },
    handleExportValueInput(product) {
      if (product.export_value === null || product.export_value === undefined || product.export_value === '') {
        return
      }

      if (product.export_value < 0) {
        product.export_value = 0
      }

      if (product.export_value > product.inventory_count) {
        product.export_value = product.inventory_count
        this.showToast(`حداکثر مقدار مجاز برای این محصول ${product.inventory_count} است.`)
      }
    },
    fetchCategories() {
      this.request({
        url: this.endpoint('api/rootCategories'),
        method: 'get',
        success: (data) => {
          this.categories = data
        }
      })
    },
    fetchCurrency() {
      this.request({
        url: this.endpoint('main/currency'),
        method: 'get',
        success: (data) => {
          this.currencies = data
        }
      })
    },

    fetchFeatures() {
      this.request({
        url: this.endpoint('product/featureTree'), method: 'get',
        success: (data) => {
          this.features = data
        }
      })
    },
    fetchAvails() {
      this.request({
        url: this.endpoint('product/availsTree'),
        method: 'get',
        success: (data) => {
          this.avails = data
        }
      })
    },

    showToast(msg) {
      this.toast.message = msg
      this.toast.show = true
      setTimeout(() => {
        this.toast.show = false
      }, 3000)
    },

    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },

    async fetchProducts() {
      this.loading = true;

      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      };

      Object.keys(params).forEach(k => {
        if (params[k] === '') delete params[k];
      });

      this.request({
        url: this.endpoint('product/inventoryProducts'),
        method: 'get',
        params,
        success: async (data) => {
          if (this.navigatingOut) return;

          this.products = data.results;
          this.totalProducts = data.count;
          this.loading = false;

          this.products.forEach(p => {
            if (p.export_price === undefined || p.export_price === null) {
              this.$set(p, 'export_price', p.base_price);
            }
            if (p.export_value === undefined || p.export_value === null) {
              this.$set(p, 'export_value', null);
            }
          });

          await this.$nextTick();

          this.applyExportSessionToProducts();
        },
        error: () => {
          this.loading = false;
        }
      });
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchProducts()
    },

    resetFilters() {
      this.filters = {
        id_in: '',
        search_value: '',
        sku: '',
        min_price: '',
        max_price: '',
        min_inventory: '',
        max_inventory: '',
        category_tree: '',
        brand_in: '',
        status_in: '',
        content_status: '',
        catalog_need: '',
        currency_in: '',
        is_ai: null,
        supplier: ''
      };
      this.applyFilters()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchProducts()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalProducts) {
        this.currentPage++
        this.fetchProducts()
      }
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchProducts()
      }
    },

    syncExportSession() {
      this.request({
        url: this.endpoint('product/inventory-export/items/'),
        method: 'get',
        success: (data) => {
          const session = {}
          for (let item of (data.items || [])) {
            session[item.id] = {
              value: item.value,
              price: item.price,
            }
          }
          this.exportSession = session

          this.applyExportSessionToProducts()
          this.showToast('سشن خروجی بروزرسانی شد')
        }
      })
    },

    isInExport(product) {
      return this.exportSession[product.id] !== undefined
    },

    addToExport(product) {
      const value = product.export_value

      if (value === null || value === undefined || value === '') {
        this.showToast('لطفاً مقدار را وارد کنید')
        return
      }

      if (value > product.inventory_count) {
        this.showToast('مقدار انتخابی نمی‌تواند از موجودی بیشتر باشد')
        product.export_value = product.inventory_count
        return
      }

      if (value < 0) {
        this.showToast('مقدار نمی‌تواند منفی باشد')
        product.export_value = 0
        return
      }

      let priceToSend = product.export_price
      if (priceToSend === null || priceToSend === undefined || priceToSend === 0) {
        priceToSend = product.base_price || 0
      }

      this.request({
        url: this.endpoint('product/inventory-export/add/'),
        method: 'post',
        data: {
          id: product.id,
          value: value,
          price: priceToSend,
        },
        success: (data) => {
          const session = {}
          for (let item of (data.items || [])) {
            session[item.id] = {
              value: item.value,
              price: item.price,
            }
          }
          this.exportSession = session
          this.showToast('محصول در سشن خروجی ثبت شد')
        }
      })
    },

    exportXlsx() {
      if (this.exportItemsCount === 0 || this.exporting) return

      this.computeExportSummary()

      this.exportConfirmVisible = true
    },
    confirmExportFinalize() {
      if (this.exportItemsCount === 0) {
        this.showToast('هیچ آیتمی برای خروجی ثبت نشده.')
        return
      }

      this.computeExportSummary()

      this.request({
        url: this.endpoint('product/inventory-export/confirm/'),
        method: 'post',
        success: () => {
          this.exportSession = {}

          this.products.forEach(p => {
            p.export_value = null
            p.export_price = p.base_price
          })

          this.fetchProducts()

          this.exportConfirmVisible = false

          this.showToast('خروجی دستی ثبت شد و موجودی‌ها بروزرسانی شدند.')
        },
        error: (err) => {
          const detail = err?.response?.data?.detail || 'خطا در تأیید خروجی.'
          this.showToast(detail)
        }
      })
    },
    confirmExportDownload() {
      if (this.exportItemsCount === 0 || this.exporting) return

      this.exporting = true

      const url = this.endpoint(`product/inventory-export/export-xlsx/?token=${this.token}`)
      window.location = url

      this.exporting = false
      this.showToast('خروجی اکسل شروع شد')
    },


    resetExport() {
      this.request({
        url: this.endpoint('product/inventory-export/reset/'),
        method: 'delete',
        success: () => {
          this.exportSession = {}
          this.products.forEach(p => {
            p.export_value = null
          })
          this.showToast('لیست خروجی خالی شد')
        }
      })
    }
  },
  mounted() {
    this.fetchProducts();
    this.fetchAvails();
    this.fetchFeatures();
    this.fetchBrands();
    this.fetchCurrency();
    this.syncExportSession()
  }
}
</script>

<style>
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}
</style>
